(() => {
  if (window.__homaLoomInit) return;
  window.__homaLoomInit = true;

  const root = document.querySelector('[data-hl-page]');
  if (!root) return;

  const $ = (sel, el = root) => el.querySelector(sel);
  const $$ = (sel, el = root) => Array.from(el.querySelectorAll(sel));

  /* Desktop locks the window and scrolls .page-wrapper. Scroll listeners on
     window never fire there, so pinned scenes stay on the first frame. */
  const scroller = document.querySelector('.page-wrapper');
  const innerScrollMq = window.matchMedia('(min-width: 990px)');
  const usesInnerScroll = () =>
    Boolean(scroller) && innerScrollMq.matches;
  const currentScroll = () => (usesInnerScroll() ? scroller.scrollTop : window.scrollY);
  const scrollToPos = (top) => {
    const el = usesInnerScroll() ? scroller : window;
    el.scrollTo({ top, behavior: 'smooth' });
  };
  const bindScroll = (fn) => {
    window.addEventListener('scroll', fn, { passive: true });
    scroller?.addEventListener('scroll', fn, { passive: true });
  };

  /* ---------- fade-in ---------- */
  const fadeEls = $$('.hl-fade-up');
  if (fadeEls.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      },
      {
        threshold: 0.12,
        root: usesInnerScroll() ? scroller : null,
        rootMargin: '0px 0px -40px 0px',
      }
    );
    fadeEls.forEach((el) => io.observe(el));
  } else {
    fadeEls.forEach((el) => el.classList.add('is-in'));
  }

  /* ---------- subnav ---------- */
  const techEl = $('#tech-specs');
  const openTechSpecs = () => {
    if (!techEl) return;
    const proTab = techEl.querySelector('[data-tech-tab="pro"]');
    if (proTab) proTab.click();
    const first = techEl.querySelector('[data-tech-model="pro"] .hl-tech__row');
    if (first && !first.classList.contains('is-open')) {
      first.querySelector('.hl-tech__trigger')?.click();
    }
    const y = techEl.getBoundingClientRect().top + currentScroll() - 70;
    scrollToPos(y);
  };

  $$('[data-hl-tech-specs]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openTechSpecs();
    });
  });

  $$('[data-hl-scroll-top]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      scrollToPos(0);
    });
  });

  if (location.hash === '#tech-specs') {
    setTimeout(openTechSpecs, 200);
  }

  /* ---------- shop carousel + PDP ---------- */
  const SHOP_COLORS = [
    { name: 'Light Stone', swatch: '#e8e6e3' },
    { name: 'Obsidian', swatch: '#1c1c1c' },
    { name: 'Warm Sand', swatch: '#d2c2a6' },
  ];
  const SHOP_SLIDES = [
    { name: 'Loom', color: 0 },
    { name: 'Loom', color: 1 },
    { name: 'Loom', color: 2 },
    { name: 'Loom Mini', color: 0 },
    { name: 'Loom Mini', color: 1 },
    { name: 'Loom Mini', color: 2 },
  ];

  const shop = $('[data-hl-shop]');
  if (shop) {
    let index = 0;
    let shown = 0;
    let leaveTimer = 0;
    const slides = $$('[data-shop-slide]', shop);
    const shopReduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const dots = $$('[data-shop-dot]', shop);
    const nameEl = $('[data-shop-name]', shop);
    const colorNameEl = $('[data-shop-color-name]', shop);
    const colorPrev = $('[data-shop-color-preview]', shop);
    const swatches = $$('[data-shop-swatch]', shop);
    const modelBtns = $$('[data-shop-model-btn]', shop);
    const priceEl = $('[data-shop-price]', shop);
    const stockEl = $('[data-shop-stock]', shop);
    const variantInput = $('[data-shop-variant-id]', shop);
    const addBtn = $('[data-shop-add]', shop);

    const variantFor = (model) => {
      const isMini = model === 'Loom Mini';
      return {
        id: shop.dataset[isMini ? 'shopMiniId' : 'shopLoomId'],
        price: shop.dataset[isMini ? 'shopMiniPrice' : 'shopLoomPrice'],
        available: shop.dataset[isMini ? 'shopMiniAvailable' : 'shopLoomAvailable'] === 'true',
      };
    };

    const syncPdp = () => {
      const slide = SHOP_SLIDES[index];
      const v = variantFor(slide.name);
      if (priceEl && v.price && !document.querySelector('[data-hf-inquiry], .hf-inquiry')) priceEl.textContent = v.price;
      if (stockEl && v.id) {
        stockEl.textContent = v.available ? 'In stock' : 'Sold out';
        stockEl.classList.toggle('is-sold-out', !v.available);
      }
      if (variantInput && v.id) variantInput.value = v.id;
      const inquiryVariant = $('[name="contact[variant]"]', shop);
      if (inquiryVariant) inquiryVariant.value = slide.name === 'Loom Mini' ? 'Loom mini' : 'Loom';
      if (addBtn) {
        addBtn.disabled = !v.id || !v.available;
        addBtn.textContent = v.available ? 'Add to basket' : 'Sold out';
      }
      modelBtns.forEach((btn) => {
        btn.classList.toggle('is-active', btn.dataset.shopModelBtn === slide.name);
      });
    };

    const paintChrome = () => {
      const slide = SHOP_SLIDES[index];
      const color = SHOP_COLORS[slide.color];
      dots.forEach((el, i) => el.classList.toggle('is-active', i === index));
      if (nameEl) nameEl.textContent = slide.name === 'Loom Mini' ? 'Loom mini' : slide.name;
      if (colorNameEl) colorNameEl.textContent = color.name;
      if (colorPrev) colorPrev.style.background = color.swatch;
      swatches.forEach((el, i) => el.classList.toggle('is-active', slide.color === i));
      syncPdp();
    };

    const showNow = (i) => {
      slides.forEach((el, n) => {
        el.classList.toggle('is-active', n === i);
        el.classList.remove('is-leaving');
      });
      shown = i;
    };

    const go = (i) => {
      const next = (i + SHOP_SLIDES.length) % SHOP_SLIDES.length;
      if (next === index && shown === next && !leaveTimer) return;
      clearTimeout(leaveTimer);
      leaveTimer = 0;
      index = next;
      paintChrome();
      if (shopReduced.matches || shown === next) {
        showNow(next);
        return;
      }
      const outgoing = slides[shown];
      slides.forEach((el) => {
        el.classList.remove('is-active');
        el.classList.remove('is-leaving');
      });
      if (outgoing) outgoing.classList.add('is-leaving');
      leaveTimer = setTimeout(() => {
        if (outgoing) outgoing.classList.remove('is-leaving');
        slides[index].classList.add('is-active');
        shown = index;
        leaveTimer = 0;
      }, 350);
    };

    $('[data-shop-prev]', shop)?.addEventListener('click', () => go(index - 1));
    $('[data-shop-next]', shop)?.addEventListener('click', () => go(index + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => go(i)));
    swatches.forEach((sw, i) => {
      sw.addEventListener('click', () => {
        const isLoom = index < 3;
        go((isLoom ? 0 : 3) + i);
      });
    });
    modelBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const model = btn.dataset.shopModelBtn;
        const color = SHOP_SLIDES[index].color;
        go((model === 'Loom' ? 0 : 3) + color);
      });
    });
    paintChrome();
  }

  /* ---------- Gemini bubbles ---------- */
  const geminiStage = $('[data-hl-gemini]');
  if (geminiStage) {
    const bubbles = $$('[data-gemini-bubble]', geminiStage);

    const runBubble = (el) => {
      const text = el.dataset.text || '';
      const sub = el.dataset.sub || '';
      const isAI = el.dataset.ai === 'true';
      const delay = Number(el.dataset.delay || 0);
      const textEl = el.querySelector('[data-gemini-text]');
      const subEl = el.querySelector('[data-gemini-sub]');
      const loadingEl = el.querySelector('[data-gemini-loading]');
      const contentEl = el.querySelector('[data-gemini-content]');

      setTimeout(() => {
        el.classList.add('is-visible');
        const startType = () => {
          if (loadingEl) loadingEl.hidden = true;
          if (contentEl) contentEl.hidden = false;
          let len = 0;
          const tick = () => {
            if (len >= text.length) {
              if (sub && subEl) {
                subEl.hidden = false;
                subEl.textContent = sub;
              }
              const cursor = el.querySelector('[data-gemini-cursor]');
              if (cursor) cursor.remove();
              return;
            }
            len += 1;
            if (textEl) {
              textEl.textContent = text.slice(0, len);
            }
            setTimeout(tick, 30);
          };
          tick();
        };

        if (isAI) {
          if (loadingEl) loadingEl.hidden = false;
          if (contentEl) contentEl.hidden = true;
          setTimeout(startType, 800);
        } else {
          startType();
        }
      }, delay);
    };

    const start = () => bubbles.forEach(runBubble);

    if ('IntersectionObserver' in window) {
      const obs = new IntersectionObserver(
        ([e]) => {
          if (e.isIntersecting) {
            start();
            obs.disconnect();
          }
        },
        { threshold: 0.3, root: usesInnerScroll() ? scroller : null }
      );
      obs.observe(geminiStage);
    } else {
      start();
    }
  }

  /* ---------- EQ ---------- */
  const eqModes = {
    Flat: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    Vocal: [0, -1, -1, 0, 2, 3, 4, 3, 1, 0],
    Bass: [5, 5, 3, 1, 0, 0, 0, 0, 1, 1],
    Night: [-4, -3, -2, 0, 1, 2, 2, 1, -1, -2],
    Movie: [4, 4, 2, 0, 1, 2, 2, 3, 4, 3],
  };

  const eqRoot = $('[data-hl-eq]');
  if (eqRoot) {
    let mode = 'Flat';
    const knobs = $$('[data-eq-knob]', eqRoot);
    const dbs = $$('[data-eq-db]', eqRoot);
    const modeBtns = $$('[data-eq-mode]', eqRoot);

    const apply = () => {
      const vals = eqModes[mode] || eqModes.Flat;
      vals.forEach((db, i) => {
        const pct = (db / 6) * 50;
        if (knobs[i]) knobs[i].style.top = `${50 - pct}%`;
        if (dbs[i]) dbs[i].textContent = String(db);
      });
      modeBtns.forEach((btn) => {
        btn.classList.toggle('is-active', btn.dataset.eqMode === mode);
      });
    };

    modeBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        mode = btn.dataset.eqMode;
        apply();
      });
    });
    $('[data-eq-reset]', eqRoot)?.addEventListener('click', () => {
      mode = 'Flat';
      apply();
    });
    apply();
  }

  /* ---------- 40W sound carousel ---------- */
  const soundScroller = $('[data-hl-sound-scroller]');
  if (soundScroller) {
    const video = $('[data-hl-sound-video]');
    const pauseBtn = $('[data-hl-sound-pause]');
    const reducedSound = window.matchMedia('(prefers-reduced-motion: reduce)');
    let soundPaused = reducedSound.matches;
    let soundTimer = 0;

    const goSoundSlide = (dir = 1) => {
      const max = soundScroller.scrollWidth - soundScroller.clientWidth;
      if (max <= 8) return;
      const card = soundScroller.querySelector('.hl-sound__card');
      const step = Math.min(card ? card.getBoundingClientRect().width + 20 : soundScroller.clientWidth, max);
      if (dir > 0 && soundScroller.scrollLeft >= max - 8) {
        soundScroller.scrollTo({ left: 0, behavior: 'smooth' });
        return;
      }
      if (dir < 0 && soundScroller.scrollLeft <= 8) {
        soundScroller.scrollTo({ left: max, behavior: 'smooth' });
        return;
      }
      soundScroller.scrollTo({
        left: Math.max(0, Math.min(max, soundScroller.scrollLeft + dir * step)),
        behavior: 'smooth',
      });
    };

    const armSound = () => {
      clearInterval(soundTimer);
      soundTimer = 0;
      if (soundPaused || reducedSound.matches) return;
      soundTimer = setInterval(() => goSoundSlide(1), 7000);
    };

    pauseBtn?.addEventListener('click', () => {
      soundPaused = true;
      pauseBtn.setAttribute('aria-pressed', 'true');
      video?.pause();
      armSound();
    });

    $('[data-hl-sound-play]')?.addEventListener('click', () => {
      if (soundPaused) {
        soundPaused = false;
        pauseBtn?.setAttribute('aria-pressed', 'false');
        if (!reducedSound.matches) video?.play?.().catch(() => {});
        armSound();
        return;
      }
      goSoundSlide(1);
    });

    if (reducedSound.matches) video?.pause();
    armSound();
  }

  /* ---------- Timeline (shared index) ---------- */
  const CLIP_END = [15, 30, 44, 59, 74, 100];
  const LINE_SEGS = [
    { left: 16.5, width: 7.2 },
    { left: 31.1, width: 7.2 },
    { left: 45.5, width: 7.7 },
    { left: 60.4, width: 7.7 },
    { left: 75.4, width: 7.8 },
  ];
  const SCENE_POS = [13, 27.5, 42, 57, 72, 87];

  let activeTimeline = 0;
  let timelineTimer = null;

  const timelineSection = $('[data-hl-timeline]');
  const miniStage = $('[data-hl-mini-timeline]');

  const startTimelineAuto = () => {
    if (timelineTimer) clearInterval(timelineTimer);
    timelineTimer = setInterval(() => setTimeline(activeTimeline + 1, false), 8000);
  };

  const setTimeline = (index, restart = true) => {
    activeTimeline = ((index % 6) + 6) % 6;

    if (timelineSection) {
      $$('[data-tl-bg]', timelineSection).forEach((el, i) => {
        el.classList.toggle('is-active', i === activeTimeline);
      });
      $$('[data-tl-card]', timelineSection).forEach((el, i) => {
        el.classList.toggle('is-active', i === activeTimeline);
      });
      const fill = $('[data-tl-bar-fill]', timelineSection);
      if (fill) {
        fill.style.clipPath = `inset(0 ${100 - CLIP_END[activeTimeline]}% 0 0)`;
      }
      const segWrap = $('[data-tl-progress-seg]', timelineSection);
      const bar = $('[data-tl-progress-bar]', timelineSection);
      const seg = LINE_SEGS[activeTimeline];
      if (segWrap && seg) {
        segWrap.style.left = `${seg.left}%`;
        segWrap.style.width = `${seg.width}%`;
        segWrap.hidden = false;
      } else if (segWrap) {
        segWrap.hidden = true;
      }
      if (bar) {
        bar.classList.remove('is-running');
        void bar.offsetWidth;
        if (seg) bar.classList.add('is-running');
      }
    }

    if (miniStage) {
      $$('[data-mini-img]', miniStage).forEach((el, i) => {
        el.classList.toggle('is-active', i === activeTimeline);
      });
      $$('[data-mini-bar]', miniStage).forEach((el, i) => {
        el.classList.toggle('is-active', i === activeTimeline);
        el.classList.toggle('is-done', i <= activeTimeline);
      });
      const timeEl = $('[data-mini-time]', miniStage);
      const titleEl = $('[data-mini-title]', miniStage);
      const card = $$('[data-tl-card]', timelineSection || root)[activeTimeline];
      if (timeEl && card) timeEl.textContent = card.dataset.time || '';
      if (titleEl && card) titleEl.textContent = (card.dataset.title || '').replace(/&#10;/g, '\n');
    }

    if (restart) startTimelineAuto();
  };

  if (timelineSection) {
    SCENE_POS.forEach((center, i) => {
      const hot = document.createElement('button');
      hot.type = 'button';
      hot.className = 'hl-timeline__hotspot';
      hot.style.left = `${center - 7}%`;
      hot.setAttribute('aria-label', `Scene ${i + 1}`);
      hot.addEventListener('click', () => setTimeline(i));
      $('[data-tl-bar]', timelineSection)?.appendChild(hot);
    });
  }

  if (miniStage) {
    $$('[data-mini-bar]', miniStage).forEach((bar, i) => {
      bar.addEventListener('click', () => setTimeline(i));
    });
  }

  if (timelineSection || miniStage) {
    setTimeline(0);
  }

  /* ---------- Phone mockup ---------- */
  const phone = $('[data-hl-phone]');
  if (phone) {
    let screen = 'hub';
    let musicOpen = false;
    let playing = true;
    let liked = false;
    let room = 'All';
    const devices = { ceiling: true, floor: false, climate: true, camera: false };
    const quick = { follow: false, movie: false, vocal: false };
    const scenesOn = {};
    let toastTimer = null;

    const toastEl = $('[data-phone-toast]', phone);
    const likeBtn = $('[data-phone-like]', phone);
    const flash = (msg) => {
      if (!toastEl) return;
      toastEl.textContent = msg;
      toastEl.classList.add('is-on');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => toastEl.classList.remove('is-on'), 1400);
    };

    const showScreen = (name) => {
      screen = name;
      musicOpen = false;
      phone.classList.remove('is-music');
      $$('[data-phone-pane]', phone).forEach((pane) => {
        pane.classList.toggle('is-active', pane.dataset.phonePane === name);
      });
      $$('[data-phone-tab]', phone).forEach((tab) => {
        const on = tab.dataset.phoneTab === name;
        tab.classList.toggle('is-active', on);
        if (on) tab.setAttribute('aria-current', 'page');
        else tab.removeAttribute('aria-current');
      });
    };

    const openMusic = () => {
      musicOpen = true;
      phone.classList.add('is-music');
    };

    const syncPlaying = () => {
      phone.classList.toggle('is-playing', playing);
      $$('[data-phone-play]', phone).forEach((btn) => {
        btn.setAttribute('aria-label', playing ? 'Pause' : 'Play');
      });
    };

    const setRoom = (next) => {
      room = next;
      $$('[data-phone-room]', phone).forEach((btn) => {
        btn.classList.toggle('is-active', btn.dataset.phoneRoom === room);
      });
      $$('[data-phone-speaker]', phone).forEach((card) => {
        card.hidden = room !== 'All' && card.dataset.room !== room;
      });
    };

    phone.addEventListener('click', (event) => {
      const play = event.target.closest('[data-phone-play]');
      if (play && phone.contains(play)) {
        event.stopPropagation();
        playing = !playing;
        syncPlaying();
        return;
      }

      const closeMusic = event.target.closest('[data-phone-music-close]');
      if (closeMusic) {
        musicOpen = false;
        phone.classList.remove('is-music');
        return;
      }

      const like = event.target.closest('[data-phone-like]');
      if (like) {
        liked = !liked;
        phone.classList.toggle('is-liked', liked);
        likeBtn?.setAttribute('aria-pressed', String(liked));
        return;
      }

      const tab = event.target.closest('[data-phone-tab]');
      if (tab) {
        showScreen(tab.dataset.phoneTab);
        return;
      }

      const roomBtn = event.target.closest('[data-phone-room]');
      if (roomBtn) {
        setRoom(roomBtn.dataset.phoneRoom);
        flash(room);
        return;
      }

      const device = event.target.closest('[data-phone-device]');
      if (device) {
        const key = device.dataset.phoneDevice;
        devices[key] = !devices[key];
        device.classList.toggle('is-on', devices[key]);
        const sub = device.querySelector('[data-device-sub]');
        if (sub) sub.textContent = devices[key] ? device.dataset.onSub : device.dataset.offSub;
        flash(devices[key] ? 'Turned on' : 'Turned off');
        return;
      }

      const allOff = event.target.closest('[data-phone-all-off]');
      if (allOff) {
        const turningOff = Object.values(devices).some(Boolean);
        Object.keys(devices).forEach((key) => {
          devices[key] = !turningOff;
        });
        $$('[data-phone-device]', phone).forEach((btn) => {
          const key = btn.dataset.phoneDevice;
          btn.classList.toggle('is-on', devices[key]);
          const sub = btn.querySelector('[data-device-sub]');
          if (sub) sub.textContent = devices[key] ? btn.dataset.onSub : btn.dataset.offSub;
        });
        flash(turningOff ? 'All off' : 'All on');
        return;
      }

      const trigger = event.target.closest('[data-phone-trigger]');
      if (trigger) {
        const name = trigger.dataset.phoneTrigger;
        if (name === 'New trigger') {
          showScreen('scenes');
          return;
        }
        scenesOn[name] = !scenesOn[name];
        trigger.classList.toggle('is-on', scenesOn[name]);
        flash(scenesOn[name] ? `${name} on` : `${name} off`);
        return;
      }

      const scene = event.target.closest('[data-phone-scene]');
      if (scene) {
        const name = scene.dataset.phoneScene;
        scenesOn[name] = !scenesOn[name];
        scene.classList.toggle('is-on', scenesOn[name]);
        flash(scenesOn[name] ? `${name} on` : `${name} off`);
        return;
      }

      const quickBtn = event.target.closest('[data-phone-quick]');
      if (quickBtn) {
        const key = quickBtn.dataset.phoneQuick;
        quick[key] = !quick[key];
        quickBtn.classList.toggle('is-on', quick[key]);
        if (key === 'follow') {
          const sub = quickBtn.querySelector('[data-quick-sub]');
          if (sub) sub.textContent = quick[key] ? 'On' : 'Off';
        }
        const name = quickBtn.querySelector('.hl-phone__quick-name');
        flash(name ? name.textContent : key);
        return;
      }

      const speaker = event.target.closest('[data-phone-speaker]');
      if (speaker) {
        const name = speaker.querySelector('.hl-phone__speaker-name');
        if (name) flash(name.textContent);
        openMusic();
        return;
      }

      const profile = event.target.closest('[data-phone-profile]');
      if (profile) {
        const name = profile.dataset.phoneProfile;
        $$('[data-phone-profile]', phone).forEach((row) => {
          row.classList.toggle('is-on', row === profile && row.classList.contains('hl-phone__profile-row'));
        });
        flash(name);
        return;
      }

      if (event.target.closest('[data-phone-music-open]')) {
        openMusic();
        return;
      }

      const note = event.target.closest('[data-phone-flash]');
      if (note) flash(note.dataset.phoneFlash);
    });

    showScreen('hub');
    syncPlaying();
  }

  /* ---------- Tech specs ---------- */
  const tech = $('[data-hl-tech]');
  if (tech) {
    $$('[data-tech-tab]', tech).forEach((tab) => {
      tab.addEventListener('click', () => {
        const id = tab.dataset.techTab;
        $$('[data-tech-tab]', tech).forEach((t) => {
          t.classList.toggle('is-active', t === tab);
        });
        $$('[data-tech-model]', tech).forEach((panel) => {
          panel.classList.toggle('is-active', panel.dataset.techModel === id);
        });
        $$('.hl-tech__row.is-open', tech).forEach((row) => row.classList.remove('is-open'));
      });
    });

    $$('.hl-tech__trigger', tech).forEach((btn) => {
      btn.addEventListener('click', () => {
        const row = btn.closest('.hl-tech__row');
        if (!row) return;
        const open = row.classList.contains('is-open');
        row.classList.toggle('is-open', !open);
        btn.setAttribute('aria-expanded', String(!open));
      });
    });
  }

  /* ---------- Pinned three-screen feature story ---------- */
  const feat = $('[data-hl-feat]');
  if (feat) {
    const pin = $('[data-hl-feat-pin]', feat);
    const scenes = $$('[data-hl-feat-scene]', feat);
    const cards = $$('[data-hl-feat-card]', feat);
    const sweet = $('[data-hl-feat-sweet]', feat);
    const anchor = $('[data-hl-feat-anchor]', feat);
    const frameImg = anchor ? anchor.parentElement.querySelector('img') : null;
    const reducedMq = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobileMq = window.matchMedia('(max-width: 900px)');
    const clamp01 = (n) => Math.max(0, Math.min(1, n));
    const span = (p, a, b) => clamp01((p - a) / (b - a));
    const smooth = (t) => t * t * (3 - 2 * t);

    const placeSweet = () => {
      if (!anchor || !frameImg) return;
      const nw = frameImg.naturalWidth;
      const nh = frameImg.naturalHeight;
      const cw = frameImg.clientWidth;
      const ch = frameImg.clientHeight;
      if (!nw || !nh || !cw || !ch) {
        anchor.hidden = true;
        return;
      }
      const ir = nw / nh;
      const cr = cw / ch;
      let box;
      if (ir > cr) {
        const h = cw / ir;
        box = { left: 0, top: (ch - h) / 2, width: cw, height: h };
      } else {
        const w = ch * ir;
        box = { left: (cw - w) / 2, top: 0, width: w, height: ch };
      }
      anchor.hidden = false;
      anchor.style.left = `${box.left}px`;
      anchor.style.top = `${box.top}px`;
      anchor.style.width = `${box.width}px`;
      anchor.style.height = `${box.height}px`;
    };

    const placeCards = (expand, ready) => {
      cards.forEach((card) => {
        const targetLeft = Number(card.dataset.left);
        const targetTop = Number(card.dataset.top);
        const targetW = Number(card.dataset.w);
        const left = 39 + (targetLeft - 39) * expand;
        const top = 36 + (targetTop - 36) * expand;
        const width = 20 + (targetW - 20) * expand;
        const scale = 0.42 + 0.58 * expand;
        card.style.left = `${left}%`;
        card.style.top = `${top}%`;
        card.style.width = `${width}%`;
        card.style.transform = `scale(${scale})`;
        card.style.pointerEvents = expand > 0.25 ? 'auto' : 'none';
        card.classList.toggle('is-ready', ready);
      });
    };

    const paint = (opacities, shifts, copyShifts, expand, ready, sweetOn) => {
      scenes.forEach((scene, i) => {
        const opacity = opacities[i];
        scene.style.opacity = String(opacity);
        scene.style.visibility = opacity < 0.03 ? 'hidden' : 'visible';
        scene.style.transform = `translateY(${shifts[i]}px)`;
        scene.style.pointerEvents = i === 1 && opacity >= 0.2 ? 'auto' : 'none';
        const copy = scene.querySelector('[data-hl-feat-copy]');
        if (copy) {
          copy.style.transform = copy.dataset.anchor === 'top-left'
            ? `translateY(${copyShifts[i]}px)`
            : `translateY(calc(-50% + ${copyShifts[i]}px))`;
        }
      });
      placeCards(expand, ready);
      if (sweet) sweet.classList.toggle('is-on', sweetOn);
      placeSweet();
    };

    const clearPin = () => {
      if (!pin) return;
      pin.style.position = '';
      pin.style.top = '';
      pin.style.bottom = '';
      pin.style.left = '';
      pin.style.width = '';
      pin.style.height = '';
      pin.style.transform = '';
    };

    const apply = () => {
      const stacked = reducedMq.matches || mobileMq.matches;
      feat.classList.toggle('is-stacked', stacked);
      if (stacked) {
        clearPin();
        scenes.forEach((scene) => {
          scene.style.opacity = '';
          scene.style.visibility = '';
          scene.style.transform = '';
          scene.style.pointerEvents = '';
          const copy = scene.querySelector('[data-hl-feat-copy]');
          if (copy) copy.style.transform = '';
        });
        placeCards(1, true);
        if (sweet) sweet.classList.add('is-on');
        if (anchor) {
          anchor.hidden = false;
          anchor.style.left = '';
          anchor.style.top = '';
          anchor.style.width = '';
          anchor.style.height = '';
        }
        return;
      }
      const rect = feat.getBoundingClientRect();
      const total = feat.offsetHeight - window.innerHeight;
      const p = total > 0 ? clamp01(-rect.top / total) : 0;
      const s1 = 1 - smooth(span(p, 0.18, 0.32));
      const s2in = smooth(span(p, 0.18, 0.32));
      const s2out = 1 - smooth(span(p, 0.68, 0.82));
      const s2 = s2in * s2out;
      const s3 = smooth(span(p, 0.68, 0.82));
      const expand = smooth(span(p, 0.32, 0.56));
      paint(
        [s1, s2, s3],
        [(1 - s1) * -28, (1 - s2) * 24, (1 - s3) * 28],
        [(1 - s1) * 20, (1 - s2) * 16, (1 - s3) * -16],
        expand,
        expand > 0.45,
        s3 > 0.55
      );
    };

    const routines = $('[data-kind="routines"]', feat);
    if (routines) {
      routines.addEventListener('click', (event) => {
        const mod = event.target.closest('[data-routine]');
        if (!mod) return;
        if (mod.dataset.routine === 'dim' || mod.dataset.routine === 'spatial') {
          routines.classList.toggle('is-swapped');
        }
      });
    }
    if (frameImg) frameImg.addEventListener('load', placeSweet);

    apply();
    bindScroll(apply);
    window.addEventListener('resize', apply);
    innerScrollMq.addEventListener?.('change', apply);
    reducedMq.addEventListener?.('change', apply);
    mobileMq.addEventListener?.('change', apply);
  }
})();
